import LocationListItem from './LocationListItem'
import {AnimatePresence} from 'motion/react'

const LocationSection = ({data, type, layout}) => {
  const locations = data.filter(item => item.type === type)

  return locations.length ? (
    <section className={`location-section ${layout === 'grid' ? 'grid' : ''}`}>
      <h2>{type}</h2>
      <ul className="list">
        <AnimatePresence initial={false} mode="popLayout">
          {locations.map(item => (
            <LocationListItem
              key={`${item.type}-${item.index}`}
              item={item}
            />
          ))}
        </AnimatePresence>
      </ul>
    </section>
  ) : null
}

export default LocationSection
